const noAdsProperties = [
  '270', // chopchat.com
  '138', // hailwv.com
  '35', // titansized.com
  '54', // ramblinfan.com
];

export function shouldBlockAds(property: string): boolean {
  return noAdsProperties.includes(property);
}
